<template>
    <div class="video-container">
      <div v-if="loading" class="loading-state">
        <p>视频加载中...</p>
      </div>
      
      <div v-else-if="error" class="error-state">
        <p>{{ error }}</p>
        <button @click="fetchVideoData">重试</button>
      </div>
      
      <template v-else>
        <h3>{{ videoData.title }}</h3>
        <video 
          ref="videoPlayer"
          class="custom-video-player" 
          controls 
          preload="auto"
          :poster="videoData.thumbnail"
          @error="handleVideoError"
        >
          <source :src="videoData.url" type="video/mp4">
          您的浏览器不支持 HTML5 视频播放
        </video>
        <p class="video-description">{{ videoData.description }}</p>
      </template>
    </div>
  </template>
  
<script>
import getVideo from '@/api/get-video.js';
import {
  Toast,
} from 'mand-mobile';
  
export default {
  props: {
    videoId: {
      type: [Number, String],
      required: true,
    },
  },
    
  data() {
    return {
      loading: true,
      error: null,
      videoData: {
        title: '',
        url: '',
        thumbnail: '',
        description: '',
      },
    };
  },
    
  created() {
    this.fetchVideoData();
  },
  
  methods: {
    fetchVideoData() {
      this.loading = true;
      this.error = null;
      
      // 从Laravel API获取视频数据
      getVideo(this.videoId)
        .then(data => {
          this.videoData = data;
          this.loading = false;
        })
        .catch(error => {
          // console.error('获取视频数据失败:', error);
          Toast.failed(error.message);
          this.error = '无法加载视频，请稍后再试';
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    handleVideoError(e) {
      // console.error('视频播放错误:', e);
      Toast.failed(e.message);
      this.error = '视频播放失败，请检查网络连接或稍后再试';
    },
  },
};
</script>
  
  <style scoped>
  .video-container {
    max-width: 100%;
    margin: 0 auto;
    padding: 15px;
    border-radius: 8px;
    background-color: #f8f9fa;
    box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  }
  
  .custom-video-player {
    width: 100%;
    border-radius: 6px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }
  
  .loading-state, .error-state {
    text-align: center;
    padding: 40px 0;
  }
  
  .video-description {
    margin-top: 3vw;
    font-size: 4.15vw;
    color: #666;
  }
  
  h3 {
    margin-bottom: 3vw;
  }
  
  button {
    padding: 8px 16px;
    background-color: #4285f4;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  button:hover {
    background-color: #3367d6;
  }
  </style>